(function () {
  function reorderBars() {
    // Move black timer bar to very top
    var timerSection = document.querySelector('[id*="header_announcements_ccy4LY"]');
    if (!timerSection) return;
    var parent = timerSection.parentNode;
    if (!parent) return;
    parent.insertBefore(timerSection, parent.firstElementChild);

    // Move brown rotating bar to after the header/nav section (last position)
    var brownSection = document.querySelector('[id*="header_announcements_b6ditH"]');
    if (brownSection && brownSection.parentNode === parent) {
      parent.appendChild(brownSection);
    }
  }

  function init() {
    // Inject a looping scrolling discount message into the black bar
    var bar = document.querySelector('.color-scheme-5 .announcement-bar__text');
    if (bar && !bar.classList.contains('ve-marquee')) {
      var message = bar.textContent.trim();
      var repeated = (message + '    ').repeat(8);
      bar.classList.add('ve-marquee');
      bar.setAttribute('aria-label', message);
      bar.innerHTML =
        '<span class="ve-marquee__track">' +
          '<span class="ve-marquee__copy">' + repeated + '</span>' +
          '<span class="ve-marquee__copy" aria-hidden="true">' + repeated + '</span>' +
        '</span>';
    }
    reorderBars();
  }

  // ── Kleur kiezer modal ──────────────────────────────────────────────────
  function swatchColorName(img) {
    if (!img) return '';
    // The swatch asset carries the color code. Product handles can be old,
    // duplicated or missing, and image alt text is not a color catalog.
    var filename = decodeURIComponent(new URL(img.src, window.location.origin).pathname.split('/').pop());
    var match = filename.match(/^(?:ZOOM)?(1B|1C|60A|613|33|30|27|24|22|18|16|14|12|10|8|6|4|2|1)(?=[_.])/i);
    if (!match) return '';
    var code = match[1].toUpperCase();
    var names = {
      '1': 'Jet Black', '1B': 'Natural Black', '1C': 'Black Brown',
      '2': 'Dark Brown', '4': 'Medium Dark Brown', '6': 'Chestnut Brown',
      '8': 'Light Brown', '10': 'Light Ash Brown', '12': 'Golden Brown',
      '14': 'Dark Ash Blonde', '16': 'Honey Blonde', '18': 'Dark Blonde',
      '22': 'Light Ash Blonde', '24': 'Golden Blonde', '27': 'Strawberry Blonde',
      '30': 'Auburn', '33': 'Dark Auburn', '60A': 'Ash Silver Blonde', '613': 'Bleach Blonde'
    };
    return names[code] + ' #' + code;
  }

  function initKleurModal() {
    var wrapper = document.querySelector('.ve-ss-variant-wrapper');
    if (!wrapper || wrapper.dataset.kleurModal) return;

    var grid = wrapper.querySelector('[class*="variants-body-"]');
    if (!grid) return;

    wrapper.dataset.kleurModal = '1';

    grid.querySelectorAll('[class*="variants-item-"]').forEach(function(item) {
      var img = item.querySelector('img');
      var name = swatchColorName(img) || item.dataset.title || (img && img.alt) || '';
      if (!name) {
        var handle = new URL(item.href, window.location.origin).pathname.split('/').pop();
        var colorSlug = handle.split('extensions-')[1];
        if (colorSlug) {
          colorSlug = decodeURIComponent(colorSlug).replace(/-kopie$/, '');
          var colorCode = colorSlug.match(/-(\d+[a-z]?(?:-\d+)?)$/i);
          if (colorCode) colorSlug = colorSlug.slice(0, -colorCode[0].length);
          name = colorSlug.replace(/-/g, ' ').replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); });
          if (colorCode) name += ' #' + colorCode[1].toUpperCase();
        }
      }
      var itemUrl = new URL(item.href, window.location.origin);
      if (/\/products\/custom(?:-|$)/i.test(itemUrl.pathname) || /^anders$/i.test(name.trim()) || (img && /anders/i.test(img.src))) {
        name = 'Kleur op maat';
        var customTile = document.createElement('span');
        customTile.className = 've-kleur-custom-tile';
        customTile.textContent = name;
        if (img) img.replaceWith(customTile);
        else item.prepend(customTile);
      }
      if (!name) return;
      item.dataset.title = name;
      var caption = document.createElement('span');
      caption.className = 've-kleur-swatch-name';
      caption.textContent = name;
      item.appendChild(caption);
    });

    // Build modal
    var modal = document.createElement('div');
    modal.id = 've-kleur-modal';
    modal.innerHTML =
      '<div class="ve-kleur-modal__backdrop"></div>' +
      '<div class="ve-kleur-modal__panel">' +
        '<button class="ve-kleur-modal__close" aria-label="Sluiten">&times;</button>' +
        '<p class="ve-kleur-modal__heading">Kies je kleur</p>' +
        '<div class="ve-kleur-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.ve-kleur-modal__body').appendChild(grid);

    // Build trigger button + selected display, insert after label
    var label = wrapper.querySelector('.ve-ss-kleur-label');
    var labelText = document.createElement('span');
    labelText.textContent = 'Kleur';
    if (label.firstChild && label.firstChild.nodeType === 3) {
      label.replaceChild(labelText, label.firstChild);
    } else {
      label.insertBefore(labelText, label.firstChild);
    }

    var selectedEl = document.createElement('button');
    selectedEl.type = 'button';
    selectedEl.setAttribute('aria-haspopup', 'dialog');
    selectedEl.addEventListener('click', openModal);
    selectedEl.className = 've-kleur-selected';
    selectedEl.style.display = 'none';
    wrapper.insertBefore(selectedEl, label.nextSibling);

    var trigger = document.createElement('button');
    trigger.className = 've-kleur-trigger';
    trigger.type = 'button';
    trigger.textContent = 'Kies je kleur →';
    wrapper.insertBefore(trigger, selectedEl.nextSibling);

    // Show pre-selected color if any (.active item)
    function syncSelected(chosen) {
      var active = chosen || grid.querySelector('[class*="variants-item-"].active');
      if (!active) {
        active = Array.from(grid.querySelectorAll('a')).find(function(item) {
          var url = new URL(item.href, window.location.origin);
          var current = new URL(window.location.href);
          return url.pathname === current.pathname &&
            (!url.searchParams.has('variant') || url.searchParams.get('variant') === current.searchParams.get('variant'));
        });
      }
      if (active) {
        var img = active.querySelector('img');
        var name = active.dataset.title || '';
        labelText.textContent = 'Kleur';
        if (name) {
          selectedEl.replaceChildren();
          if (img) {
            var preview = document.createElement('img');
            preview.src = img.src;
            preview.className = 've-kleur-selected__img';
            preview.alt = '';
            selectedEl.appendChild(preview);
          }
          var selectedName = document.createElement('span');
          selectedName.className = 've-kleur-selected__name';
          selectedName.textContent = name;
          var change = document.createElement('span');
          change.className = 've-kleur-selected__change';
          change.textContent = '⌄';
          change.setAttribute('aria-hidden', 'true');
          selectedEl.setAttribute('aria-label', 'Kleur wijzigen, geselecteerd: ' + name);
          selectedEl.append(selectedName, change);
          selectedEl.style.display = 'flex';
          trigger.style.display = 'none';
        }
      }
    }

    function openModal() {
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openModal);
    modal.querySelector('.ve-kleur-modal__backdrop').addEventListener('click', closeModal);
    modal.querySelector('.ve-kleur-modal__close').addEventListener('click', closeModal);

    grid.addEventListener('click', function(e) {
      var item = e.target.closest('[class*="variants-item-"]');
      if (!item) return;
      setTimeout(function() {
        syncSelected(item);
        closeModal();
      }, 80);
    });

    syncSelected();
  }

  function tryInitKleurModal() {
    var wrapper = document.querySelector('.ve-ss-variant-wrapper');
    if (wrapper && wrapper.querySelector('[class*="variants-body-"]')) {
      initKleurModal();
    } else {
      // SS hasn't rendered yet — observe
      var observer = new MutationObserver(function() {
        if (document.querySelector('.ve-ss-variant-wrapper [class*="variants-body-"]')) {
          observer.disconnect();
          initKleurModal();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', tryInitKleurModal);

  function expandDrawerAccordions() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('accordion-custom details').forEach(function(d) {
      d.open = true;
    });
  }

  // Expand on initial load and whenever the drawer is opened
  document.addEventListener('DOMContentLoaded', function() {
    expandDrawerAccordions();
    var summary = document.querySelector('.header__icon--menu');
    if (summary) {
      summary.addEventListener('click', function() {
        setTimeout(expandDrawerAccordions, 50);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
